import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M28.925 5.543v.019L21.65 29.554A1.985 1.985 0 0 1 19.727 31a1.98 1.98 0 0 1-1.802-1.143l-4.55-9.338a.5.5 0 0 1 .096-.572l7.24-7.24a1 1 0 0 0-1.414-1.414l-7.243 7.24a.5.5 0 0 1-.573.096L2.135 14.08a2 2 0 0 1 .311-3.725L26.44 3.08h.018a2 2 0 0 1 2.468 2.463"
    }, null, -1)
  ])))
}
export default { render: render }